/**
 * Debug utility to check API configuration
 * Call this in browser console: window.debugApi()
 */
export const debugApiConfig = () => {
  if (typeof window === "undefined") {
    console.log("Not in browser environment");
    return;
  }

  const hostname = window.location.hostname;
  const apiBaseUrl = require("./apiConfig").getApiBaseUrl();

  console.log("=== API Configuration Debug ===");
  console.log("Hostname:", hostname);
  console.log("API Base URL:", apiBaseUrl);
  console.log("Full URL:", window.location.href);
  console.log("Environment:", process.env.NODE_ENV);
  console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
  console.log("REACT_APP_DEV_API_URL:", process.env.REACT_APP_DEV_API_URL);
  console.log("==============================");

  // Test backend connectivity
  fetch(`${apiBaseUrl}/api/v1/general/health`, {
    method: "GET",
    credentials: "include",
  })
    .then((res) => {
      console.log("Backend health check:", res.status, res.statusText);
      return res.text();
    })
    .then((text) => console.log("Response:", text))
    .catch((err) => console.error("Backend connection error:", err));
};

// Make it available globally for debugging
if (typeof window !== "undefined") {
  (window as any).debugApi = debugApiConfig;
}

